import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';


const styles = (theme) => ({
    root: {
    },
});

const ConfirmDialog = (props) => {
    const { t, classes, open, onClose, data } = props;
    const { user_name = '', email = '' } = data;
  
    useEffect(() => {
        
    }, []);

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => onClose(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">確認刪除 (Delete Confirmation)</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    確定要刪除這筆資料嗎？
                    (Are you sure you want to delete this record?)
                    <br />
                    <span style={{ color: '#1789c2' }}>{user_name}: {email}</span>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => onClose(false)} color="default"> 取消 (Cancel) </Button>
                <Button variant="outlined" onClick={() => onClose(true)} color="primary" autoFocus> 確定 (OK) </Button>
            </DialogActions>
            </Dialog>
        </div>
    );    
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({  
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(ConfirmDialog);


